// eslint-disable-next-line jira/restricted/graphql-tag
import gql from 'graphql-tag';
import { PROJECT } from '../../../../common/graphql/fragments';

export const PROJECTS_LIST_QUERY = gql`
	query JiraProjects {
		recentProjects: jiraProjects(context: CREATE_ISSUE, recent: true) {
			nodes {
				...Project
			}
		}
		allProjects: jiraProjects(context: CREATE_ISSUE, recent: false) {
			nodes {
				...Project
			}
		}
	}
	${PROJECT}
`;
